// transfrom the graphql viewer data into a format usable in the form
import { addProtocol } from '@general/helpers/forms.helpers';

// some transform used across all edit profile forms
export const transformViewerToForm = viewer => {
    const formData = {
        // address
        mainAddressCountry: '',
        mainAddressAddress1: '',
        mainAddressAddress2: '',
        mainAddressAddress3: '',
        mainAddressCity: '',
        mainAddressState: '',
        mainAddressZip: '',
        mainAddressPreferredMailing: '',
        mainAddressPreferredBilling: '',

        alternateAddressCountry: '',
        alternateAddressAddress1: '',
        alternateAddressAddress2: '',
        alternateAddressAddress3: '',
        alternateAddressCity: '',
        alternateAddressState: '',
        alternateAddressZip: '',
        alternateAddressPreferredMailing: '',
        alternateAddressPreferredBilling: '',

        homeAddressCountry: '',
        homeAddressAddress1: '',
        homeAddressAddress2: '',
        homeAddressAddress3: '',
        homeAddressCity: '',
        homeAddressState: '',
        homeAddressZip: '',
        homeAddressPreferredMailing: '',
        homeAddressPreferredBilling: '',

        // birthdate
        birthdateYear: '',
        birthdateMonth: '',
        birthdateDay: '',
        blogUrl: viewer.blogUrl ? viewer.blogUrl : '',
        cellPhone: viewer.cellPhone ? viewer.cellPhone : '',

        companyName: viewer.company?.name ? viewer.company.name : '',
        // companyAddressCountry: '',
        // companyAddressAddress1: '',
        // companyAddressAddress2: '',
        // companyAddressAddress3: '',
        // companyAddressState: '',
        // companyAddressCity: '',
        // companyAddressZip: '',

        description: viewer.description ? viewer.description : '',
        designations: viewer.designations ? viewer.designations.join(', ') : '',
        displayPhoto: !!viewer.displayPhoto,
        displayEmail: !!viewer.displayEmail,
        email: viewer.email ? viewer.email : '',
        fax: viewer.fax ? viewer.fax : '',

        // firstCollege = { code, name }
        firstCollegeName: viewer.firstCollege?.name ? viewer.firstCollege.name : '',
        firstCollegeCode: viewer.firstCollege?.code ? viewer.firstCollege.code : '',
        firstGraduationYear: viewer.firstGraduationYear ? viewer.firstGraduationYear.toString() : '',

        firstName: viewer.firstName ? viewer.firstName : '',
        functionalTitle: viewer.functionalTitle ? viewer.functionalTitle : '',
        gender: viewer.gender ? viewer.gender : '',
        hideAddressFields: !!viewer.hideAddressFields,
        informal: viewer.informal || '',
        lastName: viewer.lastName ? viewer.lastName : '',
        meetingInviteOptOut: !viewer.meetingInvites,
        middleName: viewer.middleName ? viewer.middleName : '',
        noCollege: viewer.noCollege,
        linkedinUrl: viewer.linkedinUrl ? viewer.linkedinUrl : '',
        personalResponsibility: viewer.personalResponsibility ? viewer.personalResponsibility : '',
        photoUrl: viewer.photoUrl ? viewer.photoUrl : '',
        prefix: viewer.prefix ? viewer.prefix : '',

        // secondCollege = { code, name }
        secondCollegeName: viewer.secondCollege?.name ? viewer.secondCollege.name : '',
        secondCollegeCode: viewer.secondCollege?.code ? viewer.secondCollege.code : '',
        secondGraduationYear: viewer.secondGraduationYear ? viewer.secondGraduationYear.toString() : '',

        secondaryEmail: viewer.secondaryEmail ? viewer.secondaryEmail : '',
        suffix: viewer.suffix ? viewer.suffix : '',
        studentMember: viewer.studentMember,
        title: viewer.title ? viewer.title : '',
        twitterUrl: viewer.twitterUrl ? viewer.twitterUrl : '',
        workPhone: viewer.workPhone ? viewer.workPhone : '',

        messages: viewer.messages ? viewer.messages : false,
        notifications: viewer.notifications ? viewer.notifications : '',
    };

    if (viewer.birthdate) {
        const parts = viewer.birthdate.split('-');
        formData.birthdateYear = parts[0] || '';
        formData.birthdateMonth = parts[1] || '';
        formData.birthdateDay = parts[2] || '';
    }

    // ADDRESSES
    // if (viewer.company && viewer.company.addresses) {
    //     const mainCompanyAddress = viewer.company.addresses.find(a => a.purpose === 'main');
    //     if (mainCompanyAddress) {
    //         formData.companyAddressCountry = mainCompanyAddress.country;
    //         formData.companyAddressAddress1 = mainCompanyAddress.address;
    //         formData.companyAddressAddress2 = mainCompanyAddress.address2;
    //         formData.companyAddressAddress3 = mainCompanyAddress.address3;
    //         formData.companyAddressCity = mainCompanyAddress.city;
    //         formData.companyAddressState = mainCompanyAddress.stateProvince;
    //         formData.companyAddressZip = mainCompanyAddress.zip;
    //     }
    // }

    if (viewer.addresses) {
        const mainAddress = viewer.addresses.find(a => a.purpose === 'main');
        if (mainAddress) {
            formData.mainAddressCountry = mainAddress.country;
            formData.mainAddressAddress1 = mainAddress.address;
            formData.mainAddressAddress2 = mainAddress.address2;
            formData.mainAddressAddress3 = mainAddress.address3;
            formData.mainAddressCity = mainAddress.city;
            formData.mainAddressState = mainAddress.stateProvince;
            formData.mainAddressZip = mainAddress.zip;
            formData.mainAddressPreferredMailing = mainAddress.preferredMailing;
            formData.mainAddressPreferredBilling = mainAddress.preferredBilling;
        }
        const alternateAddress = viewer.addresses.find(a => a.purpose === 'alternate');
        if (alternateAddress) {
            formData.alternateAddressCountry = alternateAddress.country;
            formData.alternateAddressAddress1 = alternateAddress.address;
            formData.alternateAddressAddress2 = alternateAddress.address2;
            formData.alternateAddressAddress3 = alternateAddress.address3;
            formData.alternateAddressCity = alternateAddress.city;
            formData.alternateAddressState = alternateAddress.stateProvince;
            formData.alternateAddressZip = alternateAddress.zip;
            formData.alternateAddressPreferredMailing = alternateAddress.preferredMailing;
            formData.alternateAddressPreferredBilling = alternateAddress.preferredBilling;
        }
        const homeAddress = viewer.addresses.find(a => a.purpose === 'home');
        if (homeAddress) {
            formData.homeAddressCountry = homeAddress.country;
            formData.homeAddressAddress1 = homeAddress.address;
            formData.homeAddressAddress2 = homeAddress.address2;
            formData.homeAddressAddress3 = homeAddress.address3;
            formData.homeAddressCity = homeAddress.city;
            formData.homeAddressState = homeAddress.stateProvince;
            formData.homeAddressZip = homeAddress.zip;
            formData.homeAddressPreferredMailing = homeAddress.preferredMailing;
            formData.homeAddressPreferredBilling = homeAddress.preferredBilling;
        }
    }

    // do a final conversion of null values to '' so don't have to check each address value
    for (const [key, value] of Object.entries(formData)) {
        if (value === null) {
            formData[key] = '';
        }
    }

    return formData;
};

const getBirthdateFormToViewer = ({ month, day, year }) => {
    if (!month && !day && !year) {
        return null;
    }

    const birthdate = {};
    if (year) {
        birthdate.year = parseInt(year, 10);
    }
    if (month) {
        birthdate.month = parseInt(month, 10);
    }
    if (day) {
        birthdate.day = parseInt(day, 10);
    }

    // default month to 1 if year is present
    if (year && !month) {
        birthdate.month = 1;
    }
    // default day to 1 if year is present
    if (year && !day) {
        birthdate.day = 1;
    }
    return birthdate;
};

// transform form data back into format for mutation
export const transformFormToViewer = formData => {
    // mirrors getViewer query
    const newViewer = {
        // address
        mainAddress: {
            country: formData.mainAddressCountry ? formData.mainAddressCountry : '',
            address: formData.mainAddressAddress1 ? formData.mainAddressAddress1 : '',
            address2: formData.mainAddressAddress2 ? formData.mainAddressAddress2 : '',
            address3: formData.mainAddressAddress3 ? formData.mainAddressAddress3 : '',
            city: formData.mainAddressCity ? formData.mainAddressCity : '',
            stateProvince: formData.mainAddressState ? formData.mainAddressState : '',
            zip: formData.mainAddressZip ? formData.mainAddressZip : '',
            preferredMailing: formData.mainAddressPreferredMailing,
            preferredBilling: formData.mainAddressPreferredBilling,
        },
        alternateAddress: {
            country: formData.alternateAddressCountry ? formData.alternateAddressCountry : '',
            address: formData.alternateAddressAddress1 ? formData.alternateAddressAddress1 : '',
            address2: formData.alternateAddressAddress2 ? formData.alternateAddressAddress2 : '',
            address3: formData.alternateAddressAddress3 ? formData.alternateAddressAddress3 : '',
            city: formData.alternateAddressCity ? formData.alternateAddressCity : '',
            stateProvince: formData.alternateAddressState ? formData.alternateAddressState : '',
            zip: formData.alternateAddressZip ? formData.alternateAddressZip : '',
            preferredMailing: formData.alternateAddressPreferredMailing,
            preferredBilling: formData.alternateAddressPreferredBilling,
        },
        homeAddress: {
            country: formData.homeAddressCountry ? formData.homeAddressCountry : '',
            address: formData.homeAddressAddress1 ? formData.homeAddressAddress1 : '',
            address2: formData.homeAddressAddress2 ? formData.homeAddressAddress2 : '',
            address3: formData.homeAddressAddress3 ? formData.homeAddressAddress3 : '',
            city: formData.homeAddressCity ? formData.homeAddressCity : '',
            stateProvince: formData.homeAddressState ? formData.homeAddressState : '',
            zip: formData.homeAddressZip ? formData.homeAddressZip : '',
            preferredMailing: formData.homeAddressPreferredMailing,
            preferredBilling: formData.homeAddressPreferredBilling,
        },

        // birthdate
        birthdate: null,
        blogUrl: formData.blogUrl ? addProtocol(formData.blogUrl) : null,
        cellPhone: formData.cellPhone ? formData.cellPhone : null,

        // company = { name, addresses }
        // companyAddressCountry: '',
        // companyAddressAddress1: '',
        // companyAddressAddress2: '',
        // companyAddressAddress3: '',
        // companyAddressState: '',
        // companyAddressCity: '',
        // companyAddressZip: '',

        description: formData.description ? formData.description : null,
        // true = ["on"] Formik accounts for checkbox groups.
        displayPhoto: formData.displayPhoto,
        displayEmail: formData.displayEmail,
        email: formData.email ? formData.email : null,
        fax: formData.fax ? formData.fax : null,

        // firstCollege = { code, name }
        firstCollege: formData.firstCollegeCode ? formData.firstCollegeCode : null,
        firstGraduationYear: formData.firstGraduationYear ? parseInt(formData.firstGraduationYear, 10) : null,

        functionalTitle: formData.functionalTitle ? formData.functionalTitle : null,
        gender: formData.gender ? formData.gender : null,
        hideAddressFields: formData.hideAddressFields !== '' ? formData.hideAddressFields : null,
        informal: formData.informal || null,
        linkedinUrl: formData.linkedinUrl ? addProtocol(formData.linkedinUrl) : null,
        meetingInvites: !formData.meetingInviteOptOut,
        noCollege: formData.noCollege !== '' ? formData.noCollege : null,
        personalResponsibility: formData.personalResponsibility ? formData.personalResponsibility : null,
        prefix: formData.prefix ? formData.prefix : null,

        // secondCollege = { code, name }
        secondCollege: formData.secondCollegeCode ? formData.secondCollegeCode : null,
        secondGraduationYear: formData.secondGraduationYear ? parseInt(formData.secondGraduationYear, 10) : null,

        secondaryEmail: formData.secondaryEmail ? formData.secondaryEmail : null,
        suffix: formData.suffix ? formData.suffix : null,
        title: formData.title ? formData.title : null,
        twitterUrl: formData.twitterUrl ? addProtocol(formData.twitterUrl) : null,
        workPhone: formData.workPhone ? formData.workPhone : null,
        messages: formData.messages === 'true',
        notifications: formData.notifications ? formData.notifications : '',
    };

    newViewer.birthdate = getBirthdateFormToViewer({
        year: formData.birthdateYear,
        month: formData.birthdateMonth,
        day: formData.birthdateDay,
    });

    return newViewer;
};
